import React from "react";
import * as Yup from "yup";

import Form from "@Components/Form";
import { MESSAGE_SETTINGS_URL } from "configs/constants";

const initialValues = {
  module: "",
  type: "",
  type_name: "",
  event_name: "",
  status: "",
  reporter: "",
  key: "",
  body: "",
};

const statusOptions = [
  { id: "Active", name: "Active" },
  { id: "Inactive", name: "Inactive" },
];

const MessageSettingsEditForm = () => {
  const validationSchema = Yup.object({
    body: Yup.string().required("Value is required"),
    status: Yup.string().nullable().required("Status is required"),
  });

  const formFields = [
    {
      type: "title",
      title: "Event Details",
    },
    {
      type: "renderonly",
      label: "Module",
      key: "module",
    },
    {
      type: "renderonly",
      label: "Event",
      key: "event_name",
    },
    {
      type: "renderonly",
      label: "Type",
      key: "type_name",
    },
    {
      type: "renderonly",
      label: "Send To Reporter?",
      key: "reporter",
    },
    {
      type: "reactselect",
      name: "status",
      size: "small",
      label: "Status",
      required: true,
      outerOptions: statusOptions,
      gridSize: { xs: 12, sm: 4, md: 3, lg: 2 },
    },

    {
      type: "title",
      title: "Message Details",
    },
    {
      type: "input",
      variant: "outlined",
      autoComplete: "off",
      name: "key",
      size: "small",
      label: "Title",
      gridSize: { xs: 12, sm: 8, md: 9, lg: 9 },
    },

    {
      type: "input",
      variant: "outlined",
      name: "body",
      fullWidth: true,
      multiline: true,
      rows: 3,
      required: true,
      messageboxrequired: true,
      size: "medium",
      label: "Message",
      supportedTypes:["Please do not put URL link, Mobile Number or user personal information in message content"],
  
      gridSize: { sm: 12 },
    },
  ];

  const formButtons = ["save", "cancel"];

  return (
    <Form
      initialValues={initialValues}
      submitUrl={MESSAGE_SETTINGS_URL}
      listRoute="/configurations/notification/push-notification-settings"
      formFields={formFields}
      formButtons={formButtons}
      formTitle="Notification Message Settings"
      validationSchema={validationSchema}
    />
  );
};

export default MessageSettingsEditForm;
